<template>
  <v-card
        max-width="600"
        class="mx-auto"
        color="rgb(250,250,250)"
    >
      <v-expand-transition>
        <iframe v-show="show" :src="videoLink" style="width:100%; height: 300px; border: none"></iframe>
      </v-expand-transition>
      <v-card-title>
        {{title}}
      </v-card-title>

      <v-card-subtitle>
        {{createdAt}}
      </v-card-subtitle>

      <v-card-actions>
        <v-btn v-if="pdfLink" :href="pdfLink" icon>
          <v-icon color="primary">mdi-file-pdf</v-icon>
        </v-btn>

        <v-spacer></v-spacer>

        <v-btn
            icon
            @click="show = !show"
        >
          <v-icon color="primary">{{ show ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
        </v-btn>
      </v-card-actions>

      <v-expand-transition>

        <form v-show="show" style="padding: 10px">
          <v-textarea rows="3" v-model="myComment.text" :counter="4095" filled placeholder="Dersin özeti...">
          </v-textarea>
          <v-btn @click="addComment()" :disabled="!myComment.text" class="ma-2" color="primary">
            {{commentButtonText}}
            <v-icon da right>mdi-checkbox-marked-circle</v-icon>
          </v-btn>
        </form>
      </v-expand-transition>
    </v-card>
</template>

<script>
import {CreateComment} from "@/graphql/mutations/comment";
import {COMMENT} from "@/graphql/queries";

export default {
  name: "myLectureCard",
  props: {
    videoLink: String,
    pdfLink: String,
    title: String,
    createdAt: String,
    id: String
  },
  data: () => ({
    show: false,
    fetched: false,
    myComment: {
      id: null,
      text: '',
      lecture: {
        id: null,
      },
      student: {
        id: null,
      },
      createdAt: '',
      score: 0,
      isScored: false,
      isSent: false,
    }
  }),
  computed: {
    commentButtonText: function (){
      return this.myComment.isSent ? "Tekrar Gönder" : "Gönder"
    }
  },
  apollo: {
    comment: {
      skip: function (){
        return this.fetched || !this.show
      },
      query: COMMENT,
      variables: function () {
        return {
          lectureId: this.id,
          studentId: this.$store.getters.userCls.id,
        }
      },
      result ({ data, loading }) {
        if (!loading) {
          if(data.comment != null){
            this.myComment = data.comment
          }
          this.fetched = true
        }
      },
      error(error) {
        this.$emit('raise-error',error.message)
      }
    },
  },
  methods: {
    async addComment () {
      await this.$apollo.mutate({
        mutation: CreateComment,
        variables: {
          text: this.myComment.text,
          lectureId: this.id,
          studentId: this.$store.getters.userCls.id,
        },

        update: (store, { data: { createComment } }) => {
          // Read the data from our cache for this query.
          const data = store.readQuery({ query: COMMENT, variables: {
              text: this.myComment.text,
              lectureId: this.id,
              studentId: this.$store.getters.userCls.id,
            }, })
          // Add our tag from the mutation to the end
          data.comment = createComment.comment

          this.myComment = createComment.comment
          // Write our data back to the cache.
          store.writeQuery({ query: COMMENT, variables: {
              text: this.myComment.text,
              lectureId: this.id,
              studentId: this.$store.getters.userCls.id,
            },data })
        },
      }).catch((error) => {
        // Error
        this.$emit('raise-error',error.message)
      })
    },
  }
}
</script>

<style scoped>

</style>
